import {
    Button,
    Checkbox
} from '@usitsdasdesign/dds-react';
import Text from 'atoms/Text';
import { useEffect, useState } from 'react';
import { usePagination, useSortBy, useTable } from 'react-table';
import Pagination from './Pagination';
import TableRowCard from './TableRowCard';

function Table({
    removeMultiRows,
    selectMultiRows,
    className = '',
    tableData = [],
    columns,
    tableClass = '',
    isDetailedView,
    isSelection = true,
    isShowdetails,
    isFronzen = false,
    isFrozenleft = false,
    selectedRows = [],
    selectAllRows,
    removeAllRows,
    isPagination = true,
    pagination = {
        currentPage: 4,
        pageNumberInSection: 5,
        pageLength: 10,
        onPageChange: () => { }
    },
    isSelectAll = false,
    isSelectAllChecked = false,
    isDisabled = false,
    isLoadMore = false,
    onLoadMore = () => false,
    isDefaultTableCard = false,
    isFilledHeader = false,
    isStickyHeader = false,
    tableContainerClass,
    setPagination = () => { },
    size = 'l'
}) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        state: { sortBy },
        setPageSize
    } = useTable(
        {
            columns,
            data: tableData,
            manualSortBy: true,
            disableMultiSort: true,
            initialState: {
                sortBy: [{ id: 'fields[Name]', desc: false }]
            }
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setPageSize(tableData?.length < 10 ? 10 : tableData.length);
    }, [tableData]);

    const [showDetailsArray, setShowDetailsArray] = useState(Array(tableData.length).fill(false));
    // Function to toggle details for a specific row
    const toggleRowDetails = (index) => {
        const newShowDetailsArray = [...showDetailsArray];
        newShowDetailsArray[index] = !newShowDetailsArray[index];
        setShowDetailsArray(newShowDetailsArray);
    };

    const filledHeaderStyle = 'bg-neutral-200 py-1.5 px-2';

    const sizesStyle = {
        s: {
            padding: 'py-2 px-2'
        },
        sm: {
            padding: 'py-2 px-2 align-middle'
        },
        l: {
            padding: 'py-5 px-2'
        }
    }
    
    return (
        <div className={`${className}`}>
            <div className={`overflow-auto scroll-hidden h-full ${tableContainerClass} ${isDefaultTableCard && 'hidden md:block'}`}>
                <table
                    className={`rounded-lg w-full relative ${tableClass} ${isFronzen ? 'frozen' : ''
                        } ${isFrozenleft ? 'frozenleft' : ''}`}
                    {...getTableProps()}
                >
                    <thead className={`text-left text-xs text-black ${!isFilledHeader && 'shadow-borderBottom'} ${isStickyHeader ? 'sticky top-0 bg-white z-50' : null}`}>
                        {headerGroups.map((headerGroup, i) => (
                            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                                {isSelection && i === 0 && (
                                    <th className='w-[56px] p-5'>
                                        <Checkbox
                                            isDisabled={isDisabled}
                                            onChangeHandler={(data) => {
                                                data.value ? selectAllRows() : removeAllRows();
                                            }}
                                            value={isSelectAllChecked ? isSelectAll : (selectedRows.length === tableData.length || false)}
                                        />
                                    </th>
                                )}
                                {headerGroup.headers.map((column, i) => (
                                    <>
                                        <th
                                            className={`text-black font-semibold whitespace-nowrap ${isFilledHeader ? filledHeaderStyle : column?.padding ? column?.padding : 'px-2 py-5'} ${column.thClass}`}
                                            style={{ width: column?.cellwidth ? `${column?.cellwidth}px` : 'auto' }}
                                            key={i}

                                        >
                                            <div className="flex gap-3 font-normal">
                                                {column.render('Header')}
                                                {column?.HeaderAddon}
                                            </div>
                                        </th>
                                    </>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row, i) => {
                            prepareRow(row);
                            return (
                                <>
                                    <tr
                                        className={'border-t border-b border-gray-400 border-solid border-0 whitespace-nowrap relative'}
                                        key={i}
                                        {...row.getRowProps()}
                                    >
                                        {isSelection && (
                                            <td className='w-[56px] p-5'>
                                                <Checkbox
                                                    isDisabled={row?.original?.isSelectDisabled || isDisabled}
                                                    onChangeHandler={(data) => {
                                                        data.value ? selectMultiRows(row.original) : removeMultiRows(row.original);
                                                    }}
                                                    value={selectedRows.find((item) => (item?.allocationId ? item?.allocationId === row?.original?.allocationId : item?.id === row?.original?.id)) || false}
                                                />
                                            </td>
                                        )}

                                        {row.cells.map((cell, i) => (
                                            <td
                                                key={i}
                                                className={`text-black text-sm ${sizesStyle[size].padding} ${cell.column?.tdClass} ${cell.column?.classMethod ? cell.column?.classMethod(row.original) : null}`}
                                            >
                                                <div className={`table-td`}
                                                    style={
                                                        {
                                                            width: cell.column?.cellwidth ? `${cell.column?.cellwidth}px` : 'auto',
                                                            whiteSpace: cell.column?.cellwidth ? `normal` : 'unset'

                                                        }}
                                                >
                                                    {cell.render('Cell')}
                                                </div>
                                            </td>
                                        ))}

                                    </tr>
                                    {
                                        showDetailsArray[i] && (
                                            <tr className={`relative transition-all px-4 w-[100vw] ${(!isDetailedView && !showDetailsArray[i]) ? 'md:mt-5 md:-top-3' : null}`}>
                                                <td colSpan={columns?.length}>
                                                    <div className='bg-neutral-50 p-4 grid grid-cols-2 md:grid-cols-160 gap-x-6 gap-y-6 transition-all'>
                                                        {row.original.moredata.map((detail, i) => (
                                                            <div key={i}>
                                                                <Text variant='label' color='text-gray-1100' className='mb-1'>{detail.label}</Text>
                                                                <Text variant='bodySemibold'>{detail.value}</Text>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }

                                    {
                                        isShowdetails && (
                                            <tr className='relative z-0'>
                                                <td colSpan={columns?.length} style={{ position: 'relative' }}>
                                                    <Button
                                                        label={showDetailsArray[i] ? 'View less' : 'View more'}
                                                        onClick={() => toggleRowDetails(i)}
                                                        icon={
                                                            showDetailsArray[i]
                                                                ? 'chevron_up__l__stroke'
                                                                : 'chevron_down__l__stroke'
                                                        }
                                                        kind="silent"
                                                        size="l"

                                                    />
                                                </td>
                                            </tr>
                                        )
                                    }
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {
                isDefaultTableCard && (
                    <div className='flex flex-col gap-2 md:hidden'>
                        {
                            tableData.map((card, i) => (
                                <TableRowCard
                                    key={i}
                                    columns={columns}
                                    row={card}
                                    isSelection={isSelection}
                                    selectedRows={selectedRows}
                                    selectMultiRows={selectMultiRows}
                                    removeMultiRows={removeMultiRows}
                                />
                            ))
                        }
                    </div>
                )
            }

            {
                (isPagination && pagination.pageLength > 1)
                && (
                    <Pagination
                        value={pagination.currentPage}
                        pageNumberInSection={pagination.pageNumberInSection}
                        pageLength={pagination.pageLength}
                        customClass={'mt-4'}
                        buttonsMode={'text'}
                        pageChanged={pagination.onPageChange}
                        setPagination={setPagination}
                    />
                )
            }

            {
                isLoadMore && (
                    <div className='my-3 flex justify-center'>
                        <Button
                            label='Load more'
                            size='l'
                            kind='primary'
                            onClick={onLoadMore}
                        />
                    </div>
                )
            }

        </div>
    );
}

export default Table;
